import { render, staticRenderFns } from "./CompanyTaskWidget.vue?vue&type=template&id=79f8686b&"
import script from "./CompanyTaskWidget.vue?vue&type=script&lang=js&"
export * from "./CompanyTaskWidget.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTaskWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports